<template lang="pug">
  v-container.pt-10.pb-0
    v-row( justify='space-between' align='center' )
      v-col( cols=12 md=6)
        v-row( align='start' ).mt-10.justify-center.justify-md-start
          h1.title-center.font-weight-bold.my-4.azul--text.icono-international.icono-grande( style='position: relative' v-html='Novedades.titulo').pt-7.pl-7.mb-10

      v-col( cols=12 md=6)
        v-row.justify-end.pr-5
          router-link.px-3.font-weight-bold(outlined  v-if='$route.params.articulo' tile :to='{name: "novedades"}' style='border: 3px solid; text-decoration: none' ).mt-7.rojo--text
            v-icon.mr-2.azul--text fa-angle-left
            span.azul--text Atrás

</template>
<script>
export default {
  data: ()=>({
  }),
  computed: {
    Novedades() {
      return this.$contenido.Novedades || {}
    },

  },
}
</script>